module.exports = __webpack_public_path__ + "static/img/10.29c809ac.png";